import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100 login-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "main_content_iner" }
const _hoisted_5 = { class: "row mx-0" }
const _hoisted_6 = { class: "col-md-9 login-box min-vh-100 d-flex flex-column position-relative" }
const _hoisted_7 = { class: "row justify-content-center h-100" }
const _hoisted_8 = { class: "col-md-6 h-100 d-flex flex-column py-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-center mb-5 mt-4" }, "Personal Information", -1)
const _hoisted_10 = { class: "form-group icon-addon mb-4" }
const _hoisted_11 = { class: "form-group icon-addon mb-4" }
const _hoisted_12 = { class: "row mb-4" }
const _hoisted_13 = { class: "position-relative col-2" }
const _hoisted_14 = { class: "form-control material-control dropdown-toggle d-flex justify-content-between align-items-center" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-10" }
const _hoisted_17 = { class: "form-group icon-addon mb-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex text-muted w-100" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle" })
    ]),
    /*#__PURE__*/_createElementVNode("p", null, " We will send you an verification code to your phone. ")
  ])
], -1)
const _hoisted_19 = { class: "form-group icon-addon mb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-3 primary-gradient-bg bg-picado-img text-white p-4" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "text-uppercase fw-bold" }, "Why do wee need this?"),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " We need to store your name and phone number for the reservations and to be able to send you notifications about the status of your orders. ")
], -1)
const _hoisted_21 = { class: "text-center mt-auto" }
const _hoisted_22 = { class: "btn btn-primary rounded-5 my-3 px-5 fw-bold" }
const _hoisted_23 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Submit ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  class: "d-none",
  id: "triggerModal",
  "data-bs-toggle": "modal",
  "data-bs-target": "#ThankYouModal"
}, "thank you", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_side_image = _resolveComponent("login-side-image")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_validate_phone_code = _resolveComponent("validate-phone-code")!
  const _component_thank_you_modal = _resolveComponent("thank-you-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      href: "#",
      class: "position-absolute btn-primary btn-circle b-close z-index-1k",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
    }, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_login_side_image),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode(_component_Form, {
                onSubmit: _ctx.updateProfile,
                class: "h-100 d-flex flex-column"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Field, {
                    name: "FirstName",
                    rules: { required: true },
                    modelValue: _ctx.profile.first_name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profile.first_name) = $event))
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "text",
                          placeholder: "First Name",
                          id: "FirstName",
                          class: ["form-control material-control", meta.validated && !meta.valid ? 'has-error border-danger' : ''],
                          autocomplete: "off"
                        }), null, 16),
                        _createVNode(_component_ErrorMessage, {
                          class: "text-danger",
                          name: "FirstName"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_Field, {
                    name: "LastName",
                    rules: { required: true },
                    modelValue: _ctx.profile.last_name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.profile.last_name) = $event))
                  }, {
                    default: _withCtx(({ field, meta }) => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "text",
                          placeholder: "Last Name",
                          id: "LastName",
                          class: ["form-control material-control", meta.validated && !meta.valid ? 'has-error border-danger' : ''],
                          autocomplete: "off"
                        }), null, 16),
                        _createVNode(_component_ErrorMessage, {
                          class: "text-danger",
                          name: "LastName"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.dial_code), 1),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dial_code) = $event)),
                        class: "position-absolute top-0 start-0 end-0 bottom-0",
                        style: {"opacity":"0"}
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: country.code,
                            value: country.dial_code
                          }, " (" + _toDisplayString(country.dial_code) + ") " + _toDisplayString(country.name), 9, _hoisted_15))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _ctx.dial_code]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_Field, {
                        name: "phone",
                        modelValue: _ctx.phone,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.phone) = $event))
                      }, {
                        default: _withCtx(({ field }) => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("input", _mergeProps(field, {
                              type: "tel",
                              placeholder: "Phone Number",
                              class: "form-control material-control",
                              autocomplete: "off",
                              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updatePhone()))
                            }), null, 16)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _hoisted_18
                  ]),
                  _createVNode(_component_Field, {
                    name: "email",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event))
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("input", _mergeProps(field, {
                          type: "email",
                          placeholder: "Email",
                          class: "form-control material-control",
                          readonly: "",
                          disabled: "",
                          autocomplete: "off"
                        }), null, 16)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("button", _hoisted_22, [
                      (_ctx.saving)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_24
                          ], 64))
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ])
          ]),
          (_ctx.showOtpPanel)
            ? (_openBlock(), _createBlock(_component_validate_phone_code, {
                key: 0,
                phone: _ctx.phone_number,
                onClosePanel: _ctx.closePanel
              }, null, 8, ["phone", "onClosePanel"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_thank_you_modal),
    _hoisted_25
  ]))
}